var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 50.00003433227539,
    height: 50,
    viewBox: "0 0 50.00003433227539 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_563_11484"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5985FF",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,-50,50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,100C38.8071,100,50,88.8072,50,75C50,61.1929,38.8071,50,25,50C11.1929,50,0,61.1929,0,75C0,88.8072,11.1929,100,25,100ZM25,57.50001C34.665,57.50001,42.5,65.33500000000001,42.5,75C42.5,84.66499999999999,34.665,92.5,25,92.5C15.335,92.5,7.5,84.66499999999999,7.5,75C7.5,65.33500000000001,15.335,57.50001,25,57.50001Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_563_11484)",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.828868119fa0be09f30096cc06f385b4.svg";
export { ForwardRef as ReactComponent };